<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-row>
        <v-col xs="12" sm="12" md="6" lg="8" xl="8" cols="12">
          <div class="title_page ma-3">
            <h4 class="breadcrumb_title_page">รายละเอียดสินค้า</h4>
            <v-breadcrumbs :items="sub_menu">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
            </v-breadcrumbs>
          </div>
        </v-col>
        <v-col xs="12" sm="12" md="3" lg="2" xl="2" cols="12">
          <div class="my-3">
            <v-btn
              type="button"
              class="btn_detail_data title_page"
              elevation="2"
              @click="link('/arin/pos/bestsellproduct/'+productDetailFirstArray.product_code)"
              large
              >ดูรายการขายดีของสาขา</v-btn
            >
          </div>
        </v-col>
        <v-col xs="12" sm="12" md="3" lg="2" xl="2" cols="12">
          <div class="title_page ma-3">
            <v-btn type="button" class="btn_back_page" elevation="4" @click="$router.back()" large>ย้อนกลับ</v-btn>
          </div>
        </v-col>
      </v-row>

      <section class="mt-10">
        <div class="ma-5">
          <v-card elevation="4" class="pa-3 card_relative">
            <div class="tag_header_profile d-flex">
              <div class="grad-dark-brown-arin-bg pa-2 rounded-pill"
                style="box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);z-index: 1">
                <div class="logo_timeline mx-auto my-auto">
                  <img src="@/assets/arin_assets/tag.png">
                </div>
              </div>
              <v-card elevation="3" class="card_title ml-n5">
                <div class="arin-text-color py-1 pl-8 pr-5">ข้อมูลสินค้า</div>
              </v-card>
            </div>

            <v-row class="pa-4">
              <v-col xs="12" sm="12" md="6" lg="2" xl="2" cols="12">
                <v-img max-width="160" :lazy-src="img_holder" :src="img_holder" class="mx-auto my-auto"></v-img>
              </v-col>
              <v-col xs="12" sm="12" md="6" lg="10" xl="10" cols="12">
              
                <v-row>
                  <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12" class="py-0">
                    <div class="d-flex py-2">
                      <div class="mr-2 content_text">ชื่อสินค้า :</div>
                      <div class="sub_content_text">{{ productDetailFirstArray.name }}</div>
                    </div>
                  </v-col>
                  <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12" class="py-0">
                    <div class="d-flex py-2">
                      <div class="mr-2 content_text">จำนวนสินค้าในคลังไม่ควรน้อยกว่า :</div>
                      <div class="sub_content_text">{{ productDetailFirstArray.min }} {{ productDetailFirstArray.unit }}</div>
                    </div>
                  </v-col>
                  <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12" class="py-0">
                    <div class="d-flex py-2">
                      <div class="mr-2 content_text">ชื่อทางการแพทย์ :</div>
                      <div class="sub_content_text">{{ productDetailFirstArray.name_sci }}</div>
                    </div>
                  </v-col>
                  <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12" class="py-0">
                    <div class="d-flex py-2">
                      <div class="mr-2 content_text">จำนวนสินค้าในคลังสูงสุด :</div>
                      <div class="sub_content_text">{{ productDetailFirstArray.max }} {{ productDetailFirstArray.unit }}</div>
                    </div>
                  </v-col>
                  <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12" class="py-0">
                    <div class="d-flex py-2">
                      <div class="mr-2 content_text">ประเภทสินค้า :</div>
                      <div class="sub_content_text">{{ productDetailFirstArray.product_type_name }}</div>
                    </div>
                  </v-col>
                  <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12" class="py-0">
                    <div class=" py-2">
                      <div class="mr-2 content_text">รายละเอียด :</div>
                      <div class="sub_content_text">{{ productDetailFirstArray.detail }}</div>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </div>
      </section>

      <section class="mt-15">
        <div class="ma-5">
          <v-card elevation="4" class="pa-3 card_relative">
            <div class="tag_header_profile d-flex">
              <div class="grad-dark-brown-arin-bg pa-2 rounded-pill"
                style="box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);z-index: 1">
                <div class="logo_timeline mx-auto my-auto">
                  <img src="@/assets/arin_assets/box.png">
                </div>
              </div>
              <v-card elevation="3" class="card_title ml-n5">
                <div class="arin-text-color py-1 pl-8 pr-5">สินค้าที่เข้าร่วมโปรโมชั่น</div>
              </v-card>
            </div>
            <div class="mt-4">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-center">หน่วยนับ</th>
                      <th>บาร์โค๊ด</th>
                      <th>ราคาขายปลีก</th>
                      <th>ราคาพนักงาน</th>
                      <th>ราคาสมาชิก</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="data in productDetail" :key="data.id">
                      <td class="hidden_line text-center">{{ data.unit }}</td>
                      <td class="hidden_line">{{ data.barcode }}</td>
                      <td class="hidden_line">{{ data.price_standard ? data.price_standard : '-' }}</td>
                      <td class="hidden_line">{{ data.price_register ? data.price_register : '-' }}</td>
                      <td class="hidden_line">{{ data.price_employee ? data.price_employee : '-' }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </v-card>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import img_holder from "@/assets/arin_assets/pill-box.png";
import { HTTP_ARIN } from "@/axios_arin";
// import Swal from "sweetalert2";
export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "Pos_detail_product_data",
  data() {
    return {
      loading_page: false,
      img_holder: img_holder,
      productDetail: [],
      productDetailFirstArray: [],
      footer_Props: {
        'items-per-page-text': 'รายการต่อหน้า'
      },
      sub_menu: [
        {
          text: 'ระบบ POS',
          disabled: false,
        },
        {
          text: 'คลังสินค้า',
          disabled: false,
        },
        {
          text: 'รายการสินค้า',
          disabled: false,
        },
        {
          text: 'รายละเอียดสินค้า',
          disabled: false,
          href: '#',
        },
      ],
      headers: [
        {
          text: 'หน่วยนับ',
          value: '',
          fixed: true,
          width: '250px',
          align: 'left',
        },
        {
          text: 'บาร์โค๊ด',
          value: '',
          fixed: true,
          width: '250px',
          align: 'left',
        },
        {
          text: 'ราคาขายปลีก',
          value: '',
          fixed: true,
          width: '500px',
          align: 'left',
        },
      ],
    }
  }, methods: {
    // GET ข้อมูลสินค้า
    getProductDetail() {
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      HTTP_ARIN.get('/product/productdetail/' + this.$route.params.id, config).then((res) => {
        if (res.data.successful === true) {
          this.loading_page = false;
          this.productDetail = res.data.product_detail;
          console.log(this.productDetail);
          this.productDetailFirstArray = res.data.product_detail[0];
          if (this.productDetailFirstArray.picture) {
            this.img_holder = this.productDetailFirstArray.picture
          }
          
        }
      })
    },
    link(link) {
      window.location.href = link;
    },
  },
  mounted() {
    this.getProductDetail();
  }
}
</script>

<style scoped>
.card_relative {
  position: relative;
  border-radius: 15px;
}

.logo_timeline {
  width: 25px;
  height: 25px;
  padding: 0px;
}

.logo_timeline>img {
  max-width: 25px;
}

.tag_header_profile {
  position: absolute;
  top: -30px;
  left: -15px;
}

.arin-text-color {
  color: #84611F;
  font-weight: 600;
  font-size: 18px;
}

.content_text {
  font-weight: 500;
  font-size: 16px;
  color: #909090;
}

.sub_content_text {
  font-weight: 500;
  font-size: 16px;
  color: #616A6B;
}

.btn_detail_data {
  font-size: 16px;
  color: #fff;
  background: linear-gradient(90deg, #0f71b9 0%, rgba(136, 179, 88, 0) 100%),
    #8ebbdc !important;
  border-radius: 5px;
  width: 100%;
}
</style>
